import "./team-page.css"
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import rehypeRaw from "rehype-raw";

interface TeamMember { affiliation_image : string | undefined, name : string, title : string, note : string, affiliation : string | undefined, picture : string | undefined }

const TeamPage = ( props : { title : string, team :  TeamMember[] }) => {
    


    return  <div className="body-block">
        <h1>{props.title}</h1>
        <ul className="team">
            {props.team.map( (m) => {

            let actualname = m.name;
            if(m.affiliation !== undefined)
                actualname = `${m.name} [![link](${m.affiliation_image})](${m.affiliation})`

            let pic = m.picture
            if(pic === undefined)
                pic = "/img/profile.jpg"

            return <li className="member">
                <h4><ReactMarkdown rehypePlugins={[rehypeRaw]}>{actualname}</ReactMarkdown>
                </h4>
                <img className="picture" src={pic} title="" />
                <h5>{m.title}</h5>
                {m.note != undefined ? <h6>{m.note}</h6> : <></> }
                </li>}   )}
        </ul>
    </div>
}

export default TeamPage;